module.exports = __webpack_public_path__ + "static/media/leg2.05babd69.png";